export default __webpack_public_path__ + "static/Image_6-becd31e4d8f3decb8596af3b64b1a9ec.jpg";